// @flow
import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import dataLayer from "../common/dataLayer";
import { gaReducer } from "../GA";

import type { RouterHistory, Location } from "react-router-dom";

type Props = {
  dispatch: Function,
  children: Function,
  location: Location,
  history: RouterHistory
};

type State = {
  searchQuery: string
};

type Field = "footer" | "header" | "sidebar";

class SearchLogic extends React.Component<Props, State> {
  state = {
    searchQuery: ""
  };

  updateState = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { value } = e.target;

    this.setState({
      searchQuery: value
    });
  };

  redirect = (field: Field) => {
    const { searchQuery } = this.state;
    const { pathname } = this.props.location;

    dataLayer({
      event: "event-to-ga",
      eventCategory: "Helpdesk Search",
      eventAction: `Search ${pathname}#${field}`,
      eventLabel: `Редирект на результаты поиска по запросу "${searchQuery}" из поля ${field} страницы ${pathname}`
    });

    gaReducer("CLICKBTN_SEARCH", {
      searchQuery: searchQuery
    });

    this.props.history.push(`/helpdesk/search?${searchQuery}`, {
      searchQuery
    });

    // очищаем поле после редиректа
    this.setState({
      searchQuery: ""
    });

    if (this.inputFieldRef && typeof this.inputFieldRef.blur === "function") {
      this.inputFieldRef.blur();
    }
  };

  handleEnter = (e: SyntheticKeyboardEvent<HTMLInputElement>, field: Field) => {
    if (e.keyCode === 13) {
      this.redirect(field);
    }
  };

  render() {
    return this.props.children({
      inputFieldRef: input => this.inputFieldRef = input,
      searchQuery: this.state.searchQuery,
      updateSearchQuery: this.updateState,
      redirectToSearch: this.redirect,
      redirectOnEnter: this.handleEnter
    });
  }
}

export default withRouter(connect()(SearchLogic));



// WEBPACK FOOTER //
// ./src/components/Helpdesk/SearchLogic.js